import React from 'react';

/**
 * Map flowing children, adjusting y-positions for elements that appear below
 * the flow-bottom boundary (e.g. fixed overlays positioned in page-space).
 *
 * @param {{
 *   children: React.ReactElement[],
 *   margins: { bottom: number },
 *   firstPageMargins: { top: number } | null | undefined,
 *   lastPageMargins: { bottom: number } | null | undefined,
 *   size: { height: number },
 *   pages: number,
 *   lastBoundary: number,
 * }} params
 * @returns {React.ReactElement[]}
 */
export function renderFlowingChildren({ children, margins, firstPageMargins, lastPageMargins, size, pages, lastBoundary }) {
	const flowBottom = size.height - (lastPageMargins ? lastPageMargins.bottom : margins.bottom);
	const spaceToAdd = firstPageMargins && pages > 1 ? firstPageMargins.top : 0;

	return children.map((child) => {
		const y = child.props.y;
		if (y > flowBottom) {
			return React.cloneElement(child, {
				y: lastBoundary + y + spaceToAdd,
			});
		} else {
			return child;
		}
	});
}
